import { JOBS_ROUTE } from "../../../app/api/routeConstants";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../../modes/constants";

const PARAMS_MODE_ALL = "all";
const PARAMS_MODE_HEALTHCARE = "healthcare";

export function getParamsMode(mode) {
  if (mode === HR_ALL_MODE) {
    return PARAMS_MODE_ALL;
  } else if (mode === HR_HEALTHCARE_MODE) {
    return PARAMS_MODE_HEALTHCARE;
  } else {
    return PARAMS_MODE_ALL;
  }
}

export function getModeFromParams(mode = "") {
  const paramsMode = mode.toLowerCase();
  if (paramsMode === PARAMS_MODE_ALL) {
    return HR_ALL_MODE;
  } else if (paramsMode === PARAMS_MODE_HEALTHCARE) {
    return HR_HEALTHCARE_MODE;
  } else {
    return HR_ALL_MODE;
  }
}

export function setJobsUrlParams({
  mode = HR_ALL_MODE,
  country = "",
  arealLevelOne = "",
  // type = "",
  // category = "",
}) {
  return `${JOBS_ROUTE}?mode=${getParamsMode(
    mode
  )}&country=${country}&area=${arealLevelOne}`;
  // return `${JOBS_ROUTE}?country=${country}&area=${arealLevelOne}&type=${type}&category=${category}`;
}
